var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.89258 3.59915C11.0592 4.40998 11.8642 5.69915 12.0276 7.18665",
    stroke: "#6A3CB1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.03516 7.21583C2.18682 5.73416 2.98016 4.44499 4.13516 3.62833",
    stroke: "#6A3CB1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.77734 12.215C5.45401 12.5592 6.22401 12.7517 7.03484 12.7517C7.81651 12.7517 8.55151 12.5767 9.21068 12.2558",
    stroke: "#6A3CB1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03573 4.49165C7.93135 4.49165 8.6574 3.76561 8.6574 2.86999C8.6574 1.97437 7.93135 1.24832 7.03573 1.24832C6.14011 1.24832 5.41406 1.97437 5.41406 2.86999C5.41406 3.76561 6.14011 4.49165 7.03573 4.49165Z",
    stroke: "#6A3CB1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.81698 11.62C3.7126 11.62 4.43865 10.894 4.43865 9.99834C4.43865 9.10272 3.7126 8.37668 2.81698 8.37668C1.92136 8.37668 1.19531 9.10272 1.19531 9.99834C1.19531 10.894 1.92136 11.62 2.81698 11.62Z",
    stroke: "#6A3CB1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1822 11.62C12.0778 11.62 12.8039 10.894 12.8039 9.99834C12.8039 9.10272 12.0778 8.37668 11.1822 8.37668C10.2866 8.37668 9.56055 9.10272 9.56055 9.99834C9.56055 10.894 10.2866 11.62 11.1822 11.62Z",
    stroke: "#6A3CB1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.68a661b662990b1e1eb838140799412a.svg";
export { ForwardRef as ReactComponent };